import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PublicationsTable = () => {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0); // To track the current page
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 10; // Number of items per page

  // Function to fetch publications for the current page
  useEffect(() => {
    const getPublicationsByPage = async (page) => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/publications/publications?page=${page}&size=${pageSize}`;
        const response = await axios.get(url);

        const allPublications = response.data._embedded ? response.data._embedded.publications : [];
        const totalPages = response.data.page ? response.data.page.totalPages : 0;

        setPublications(allPublications);
        setTotalPages(totalPages);
      } catch (error) {
        console.error("Error fetching publications:", error);
        setError("Failed to fetch publications.");
      } finally {
        setLoading(false);
      }
    };

    getPublicationsByPage(page); // Fetch publications for the current page
  }, [page]); // Dependency array includes `page`, so it refetches when page changes

  const handleNextPage = () => {
    if (page < totalPages - 1) {
      setPage(page + 1); // Move to next page
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage(page - 1); // Move to previous page
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">Publications</h2>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Publication ID</th>
            <th>Type</th>
            <th>Title</th>
            <th>Journal</th>
            
            <th>Contribution</th>
           
            <th>Publication Date</th>
          </tr>
        </thead>
        <tbody>
          {publications.length === 0 ? (
            <tr><td colSpan="8" className="text-center">No publications available</td></tr>
          ) : (
            publications.map((publication) => (
              <tr key={publication.id}>
                <td>{publication.id}</td>
                <td>{publication.publication}</td>
                <td>{publication.title}</td>
                <td>{publication.journal}</td>
             
                <td>{publication.contribution}</td>
               
                <td>{publication.publicationDate}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="d-flex justify-content-center">
        <button
          className="btn btn-primary mx-2"
          onClick={handlePreviousPage}
          disabled={page === 0}
        >
          Previous
        </button>
        <span className="my-auto">Page {page + 1} of {totalPages}</span>
        <button
          className="btn btn-primary mx-2"
          onClick={handleNextPage}
          disabled={page === totalPages - 1}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PublicationsTable;
